import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { CBPhaseTypes, CBRegistryPhase, IFormValues, REGISTRY_PHASE_WAITING_FOR_VALIDATION } from "../../types";
import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { useTheme } from "@mui/material/index";
import { CancelRounded, CheckCircleRounded, ContactPageRounded, MailOutlineRounded, PhoneRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";

interface RegistryPhaseInfoProps {
    title: string,
    phase: CBRegistryPhase

}

const RegistryPhaseInfo = ({title, phase}: RegistryPhaseInfoProps) => {

    const { t } = useTranslation("customerbase");
    const theme = useTheme();
    const { control } = useFormContext<IFormValues>();

    const cbDossiersWatch = useWatch<IFormValues, 'cbDossiers'>({control: control, name: "cbDossiers"});
    const [properties, setProperties] = useState({
        icon: <></>,
        stateIcon: <></>,
        stateTooltip: ''
    });

    const chooseIcon = (type: string | undefined) => {
        switch(type) {
            case CBPhaseTypes.EMAIL:
                return <MailOutlineRounded color="info"/>
            case CBPhaseTypes.MOBILE:
                return <PhoneRounded color="info"/>
            case CBPhaseTypes.DOC:
                return <ContactPageRounded color="info"/>
            
            default:
                return <></>
        }
    }

    const chooseStateIcon = (phaseType: string | undefined, verify: boolean | undefined, subState: string | undefined/*, dossier: any[]*/) => {
        
        var icon = <></>;
        const hasNotDossier = cbDossiersWatch?.length == 0;

        if(phaseType?.toUpperCase() == CBPhaseTypes.MOBILE || phaseType?.toUpperCase() == CBPhaseTypes.EMAIL)
            icon = verify ? <CheckCircleRounded sx={{color: theme.palette.success.main}}/> : <CancelRounded sx={{color: theme.palette.error.main}}/>;
        else if(phaseType?.toUpperCase() == CBPhaseTypes.DOC) {
            if(hasNotDossier)
                icon = <CancelRounded sx={{color: theme.palette.grey.A400}}/>;
            else {
                if(verify)
                    icon = <CheckCircleRounded sx={{color: theme.palette.success.main}}/>;
                else {
                    icon = subState?.toUpperCase() == REGISTRY_PHASE_WAITING_FOR_VALIDATION ? <CancelRounded sx={{color: theme.palette.warning.main}}/> : <CancelRounded sx={{color: theme.palette.error.main}}/>;
                }

            }
        }

        return icon;
    };

    const chooseStateTooltip = (phaseType: string | undefined, verify: boolean | undefined, subState: string | undefined) => {

        var label = '';
        const hasNotDossier = cbDossiersWatch?.length == 0;

        if(phaseType?.toUpperCase() == CBPhaseTypes.MOBILE || phaseType?.toUpperCase() == CBPhaseTypes.EMAIL)
            label = verify ? "verified" : "notVerified";
        
            else if(phaseType?.toUpperCase() == CBPhaseTypes.DOC) {
                if(hasNotDossier)
                    label = "notPresent";
                else {
                    if(verify)
                        label = "valid";
                    else {
                        label = subState?.toUpperCase() == REGISTRY_PHASE_WAITING_FOR_VALIDATION ? "waitingForValidation" : "notValid";
                    }

                }
            }

        return label;
    };

    useEffect(() => {
        if(!!phase) {
            setProperties({
                icon: chooseIcon(phase.phaseType),
                stateIcon: chooseStateIcon(phase.phaseType, phase.verify, phase.subState),
                stateTooltip: chooseStateTooltip(phase.phaseType, phase.verify, phase.subState)
            })
        }

        //console.log(cbDossiersWatch);

    }, [phase, cbDossiersWatch])

    return (
        <Stack direction={"row"} columnGap={1}>
            <Tooltip title={title || ''} arrow>
                {properties.icon}
            </Tooltip>
            <Typography variant="h5">:</Typography>
            <Tooltip title={t(`labels.${properties.stateTooltip}`) || ''} arrow>
                {properties.stateIcon}
            </Tooltip>
        </Stack>
    )

}

export default RegistryPhaseInfo;